import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=2082c1b0"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=2082c1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports